export const SHORT_VIDEO_EVENT_NAMES = {
    "ON_LOAD": "sv-on-load",
    'VIEW_VIDEO': 'sv-view',
    "VIDEO_MUTE": "sv-mute",
    "VIDEO_SHARE": "sv-share",
    "VIDEO_UNMUTE": "sv-unmute",
    "VIDEO_PAUSE": "sv-pause",
    "VIDEO_RESUME": "sv-resume",
    "ENTER_FULLSCREEN": "sv-enter-fullscreen",
    "EXIT_FULLSCREEN": "sv-exit-fullscreen",
    "PRODUCT_CTA_CLICK": "sv-product-cta-click",
    "ADD_TO_CART": "sv-add-to-cart",
    "CHECKOUT": "sv-checkout",
    "POLL_ANSWER": "sv-poll-answer",
    "QA_DEFAULT": "sv-qa",
    "QA_FOLLOW_UP": "sv-qa-follow-up",
    "OPEN_CART": "sv-open-cart",
	"CLOSE_CART": "sv-hide-cart",
	"REMOVE_FROM_CART": "sv-remove-from-cart",
	"DECREASE_FROM_CART": "sv-decrease-from-cart"
};

export const DEFAULT_SHORT_VIDEO_EVENT = "lora-short-video-events"

export function emitShortVideoEvent(event, data) {
    const payload = {
        name: event,
        data: data
    }
    window.dispatchEvent(
        new CustomEvent(DEFAULT_SHORT_VIDEO_EVENT, {
            detail: payload,
            composed: true,
            bubbles: true,
        })
    )
}